import { render, staticRenderFns } from "./AnatomicalCardForm.vue?vue&type=template&id=e0c5c4ec&scoped=true"
import script from "./AnatomicalCardForm.vue?vue&type=script&lang=js"
export * from "./AnatomicalCardForm.vue?vue&type=script&lang=js"
import style0 from "./AnatomicalCardForm.vue?vue&type=style&index=0&id=e0c5c4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c5c4ec",
  null
  
)

export default component.exports